import React from "react";
import ReactPlayer from 'react-player/lazy';
import axios from 'axios';
import CommonProjectViewSection from "./CommonProjectViewSection";
import { Waypoint } from "react-waypoint";
import { getCDNUrl } from "../commons/CommonFunctions";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";


class CommonManagementSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            page: 0,
            managementDataList: [],
            shouldPlay: false,
            responseMessage: ''
        }
    }

    handleEnterViewport = () => {
        this.setState({
            shouldPlay: true,
        })
    };
    handleExitViewport = () => {
        this.setState({
            shouldPlay: false
        })
    };

    componentDidMount() {
        this.getAllManagementDataList();
    };

    getAllManagementDataList = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/backend/pre/login/management/getPublicList?page=${this.state.page}&size=${this.state.size}&loginType=PRE_LOGIN&preLoginManagementType=${this.props?.sectionType}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                    this.setState({
                        managementDataList: response?.data?.body?.content,
                        responseMessage: response.data?.message
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    render() {
        const { sectionType } = this.props;
        const { managementDataList } = this.state;
       
        return (
            this.state.responseMessage === 'Success!' ?
            <>
                {managementDataList && managementDataList.length > 0 && managementDataList.slice(0, 1).map((item) => {
                    return ( 
                    <>
                        <div className='lndSPCol'>
                            <div className='lndSolVideoBlk'>
                                <a href={item?.link} data-fancybox={`video${item?.id}`}>
                                    <img 
                                        src={getCDNUrl(item?.attachment?.attachmentUrl)} alt="" />
                                    <span className="btnYoutube"></span>
                                </a>
                                {/* <Waypoint onEnter={() => this.handleEnterViewport()} onLeave={() => this.handleExitViewport()} scrollableAncestor='window'>
                                    <div>
                                        <ReactPlayer
                                            url={item?.link}
                                            width={"100%"}
                                            height={'334px'}
                                            playing={this.state.shouldPlay}
                                            controls={false}
                                            muted={true}
                                            className='react-player'
                                        />
                                    </div>
                                </Waypoint> */}
                            </div>                           
                        </div>
                        <div className='lndSPCol'>
                             <div className='lndSolHighlightBlk'>
                                <h5>{sectionType === "PROJECT" ? "Project Management" : sectionType === "FUND_RAISE" ? "Fund Raise" : sectionType === "STUDIO" ? "Studio" : "Community"} Highlights</h5>
                                <div className='row'>
                                    {item?.highlights?.slice(0, 2).map((highlights, inx) => {
                                        return <CommonProjectViewSection item={highlights} key={inx} sectionType={this.props?.sectionType} />
                                    })}
                                </div>
                            </div>
                        </div>
                    </>
                    )
                })}
            </> 
            :
            <>
                <SkeletonTheme>
                    <div className='lndSPCol'>
                        <div className='lndSolVideoBlk skeletonBlk'>
                            <a>
                                <Skeleton height={"100%"} width={"100%"}/>
                                <span className="btnYoutube"><Skeleton circle={true} height={60} width={60}/></span>
                            </a>
                        </div>                           
                    </div>
                </SkeletonTheme>
                <div className='lndSPCol'>
                    <div className='lndSolHighlightBlk'>
                        <h5>{sectionType === "PROJECT" ? "Project Management" : sectionType === "FUND_RAISE" ? "Fund Raise" : sectionType === "STUDIO" ? "Studio" : "Community"} Highlights</h5>
                        
                        <div className='row'>                            
                            {Array(2).fill().map((item, index)=>{
                                return(
                                    
                                        <div className="col-md-6">
                                            <SkeletonTheme>
                                                <div className="lndprojeventlist">
                                                    <div className="lndprojeventlistinn">
                                                        <figure>
                                                            <Skeleton height={166} width={"100%"}/>
                                                        </figure>
                                                        <div className="lndprojeventdesc">
                                                            <Skeleton height={36} width={`100%`}/>                                                            
                                                        </div>
                                                    </div>
                                                </div>      
                                            </SkeletonTheme>                               
                                        </div>
                                    )})}
                        </div>
                    </div>
                </div>
        </>
        );
    }
}

export default CommonManagementSection;